/**
 * Social / community links shown in the app shell.
 *
 * @module constants/social
 */

/** Public invite to the Aesthetic Legends Discord server. */
export const DISCORD_INVITE_URL = 'https://discord.gg/pnxdPdkeDy';
